import http from '@services/http';
export default {
  getAllMedia() {
    return http.get('Media/GetAllMedia', {});
  },

  insertMediaDocument(media) {
    return http.post('Media/InsertMediaDocument', media);
  },

  deleteMediaDocument(id) {
    return http.delete('Media/DeleteMediaDocument', {
      docId: id
    });
  }

};